<app-container-standard title="Regulering">
    <form #f="ngForm" (ngSubmit)="onSubmit(f.value)">
        <div class="form-row">

            <div class="form-group col-md-4">
                <mat-form-field class="example-full-width">
                    <input type="text" placeholder="Product fra" aria-label="Number" matInput
                        (keyup)="applyProductFilter($event.target.value)" [matAutocomplete]="autoProduct">
                    <mat-autocomplete #autoProduct="matAutocomplete">
                        <mat-option (click)="setProductFrom('')">
                            <span>-- EMPTY --</span>
                        </mat-option>
                        <mat-option *ngFor="let option of filteredProduct$ | async" (click)="setProductFrom(option)"
                            value="{{option.name}}">
                            <img class="example-option-img" aria-hidden *ngIf="option.imageUrl" [src]="option.imageUrl"
                                height="25">
                            <span>{{option.name}}</span>
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>

            <div class="form-group col-md-4">
                <mat-form-field class="example-full-width">
                    <input type="text" placeholder="Product til" aria-label="Number" matInput
                        (keyup)="applyProductFilter($event.target['value'])" [matAutocomplete]="autoProductTo">
                    <mat-autocomplete #autoProductTo="matAutocomplete">
                        <mat-option (click)="setProductTo('')">
                            <span>-- EMPTY --</span>
                        </mat-option>
                        <mat-option *ngFor="let option of filteredProduct$ | async" (click)="setProductTo(option)"
                            value="{{option.name}}">
                            <img class="example-option-img" aria-hidden *ngIf="option.imageUrl" [src]="option.imageUrl"
                                height="25">
                            <span>{{option.name}}</span>
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>

            <div class="form-group col-md-3">

                <ng-container>
                    <mat-form-field>

                        <input matInput [matDatepicker]="picker" (dateInput)="setCustomRange($event, 'start')">
                        <mat-hint>MM/DD/YYYY</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>

                    <div class="buttons">
                        <div class="example-button-row">
                            <button type="submit" class="theme-primary white-text float-right"
                                mat-flat-button>Create</button>
                        </div>
                        <div class="example-button-row">
                            <button class="theme-primary white-text float-right" (click)="applychangesforall()"
                                mat-flat-button>Apply
                                changes</button>
                        </div>
                    </div>
                </ng-container>

            </div>
            <div class="form-group col-md-1">
                <input class="form-control" type="time" name='startTime' (change)="setToTime()" id="startTime">
            </div>
        </div>



    </form>

</app-container-standard>


<app-table-standard-layout [dataSource$]="data$" [title]="'Product changes'" [columnSettings]="columnSettings"
    [rowActionButtons]="rowActionButtons" [showImport]="false">
</app-table-standard-layout>
<app-table-standard-layout [dataSource$]="getApplyChanges$" [title]="'Apply Changes'"
    [columnSettings]="columnSettingsApplyChanges" [rowActionButtons]="rowActionButtonsForApplyChanges"
    [showImport]="false">
</app-table-standard-layout>